import { useContext } from 'react';
import { LoadingSpinnerContext } from '../contexts/LoadingSpinnerContext';

export function useRootLoadingSpinner() {
  return useContext(LoadingSpinnerContext);
}
